import { render } from "./LookupIndex.vue?vue&type=template&id=d94aa6c4&scoped=true&ts=true"
import script from "./LookupIndex.vue?vue&type=script&lang=ts"
export * from "./LookupIndex.vue?vue&type=script&lang=ts"

import "./LookupIndex.vue?vue&type=style&index=0&id=d94aa6c4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94aa6c4"]])

export default __exports__